"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiGetMaintenanceResponse = instanceOfApiGetMaintenanceResponse;
exports.ApiGetMaintenanceResponseFromJSON = ApiGetMaintenanceResponseFromJSON;
exports.ApiGetMaintenanceResponseFromJSONTyped = ApiGetMaintenanceResponseFromJSONTyped;
exports.ApiGetMaintenanceResponseToJSON = ApiGetMaintenanceResponseToJSON;
exports.ApiGetMaintenanceResponseToJSONTyped = ApiGetMaintenanceResponseToJSONTyped;
/**
 * Check if a given object implements the ApiGetMaintenanceResponse interface.
 */
function instanceOfApiGetMaintenanceResponse(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isOn' in value) || value['isOn'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function ApiGetMaintenanceResponseFromJSON(json) {
    return ApiGetMaintenanceResponseFromJSONTyped(json, false);
}
function ApiGetMaintenanceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'isOn': json['is_on'],
        'startTime': (new Date(json['start_time'])),
        'endTime': (new Date(json['end_time'])),
    };
}
function ApiGetMaintenanceResponseToJSON(json) {
    return ApiGetMaintenanceResponseToJSONTyped(json, false);
}
function ApiGetMaintenanceResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'is_on': value['isOn'],
        'start_time': ((value['startTime']).toISOString()),
        'end_time': ((value['endTime']).toISOString()),
    };
}
